import { Stack } from "@mui/material";
import { CustomCheckbox } from "../../ui";
import { StarFourPointsIcon } from "../../images";
import { EllipsisTooltip } from "../../ui/CustomTooltip";
import { IconWrapper } from "../../ui/IconWrapper";
import { StarFourPoints } from "../../images/StarImg";
import { RateIndicator } from "../../../types/enums";
import { RateIndicatorIcon } from "../../ui/RateIndicatorIcon";
import { TextWrapper } from "./TextWrapper";

export const CheckboxBodyCell = ({
  value,
  minWidth,
  maxWidth,
  justifyContent = "flex-start",
  isHighlighted,
  isEditMode,
  isDisabled,
  isSelected,
  onChangeHandler,
  indicator,
  indicatorChange,
  indicatorChangeAt,
}: {
  value: string;
  minWidth: string;
  maxWidth: string;
  justifyContent?: "space-between" | "center" | "flex-start" | "flex-end";
  isHighlighted?: boolean;
  isEditMode: boolean;
  isDisabled?: boolean;
  isSelected: boolean;
  onChangeHandler: () => void;
  indicator?: RateIndicator;
  indicatorChange?: number;
  indicatorChangeAt?: string;
}) => {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      minWidth={minWidth}
      maxWidth={maxWidth}
      justifyContent={justifyContent}
      width="100%"
      padding="0 16px"
    >
      {isSelected && !isEditMode && (
        <EllipsisTooltip
          hide={false}
          tooltip={"Probable BC member among alternative candidates."}
        >
          <IconWrapper width="42px" height="fit-content">
            <StarFourPoints />
          </IconWrapper>
        </EllipsisTooltip>
      )}
      {!isSelected && !isEditMode && <Stack minWidth="42px" />}

      {isEditMode && (
        <CustomCheckbox
          className="no-drag"
          checked={isSelected}
          onChange={onChangeHandler}
          disabled={isDisabled}
          checkedIcon={<StarFourPointsIcon color="#1C3C6C" />}
        />
      )}

      <Stack minWidth="28px" alignItems="flex-start">
        <RateIndicatorIcon
          indicatorRate={indicator}
          indicatorChange={indicatorChange}
          indicatorChangeAt={indicatorChangeAt}
        />
      </Stack>

      <TextWrapper
        style={{
          minWidth: "40px",
          color: "#232323",
        }}
        isHighlighted={isHighlighted}
        text={value}
      />
    </Stack>
  );
};
